// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --accent-color: #28a745;
  --danger-color: #dc3545;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
  --text-color-dark: #343a40;
  --text-color-medium: #6c757d;
  --text-color-light: #f8f9fa;
  --card-bg: #ffffff;
  --container-bg: #f8f9fa;
  --border-color: #e9ecef;
  --shadow-light: rgba(0, 0, 0, 0.08);
  --shadow-medium: rgba(0, 0, 0, 0.15);
  --spacing-unit: 0.75rem;
}

.task-header-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.task-header-main .task-gap-header {
  gap: 0.5rem;
}
.task-header-main .filter-group label {
  display: block;
  margin-bottom: 8px;
}

.tasks-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.tasks-table thead {
  background-color: #f1f5f9;
}
.tasks-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.tasks-table tbody tr {
  transition: background-color 0.2s ease;
}
.tasks-table tbody tr:hover {
  background-color: #f9fafb;
}
.tasks-table tbody tr td {
  padding: 0.9rem 1rem;
}
.tasks-table tbody tr td:last-child {
  white-space: nowrap;
}
.tasks-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
}
.tasks-table tbody tr td:last-child button:hover {
  opacity: 0.9;
  background-color: #fef9fa;
}
.tasks-table tbody tr td:last-child button.status-btn {
  min-width: 4rem;
  padding: 0.35rem 0.7rem;
  border-radius: 0.75rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  border: none;
}
.tasks-table tbody tr td:last-child button.pending-btn {
  background: #fff3cd;
  color: #856404;
}
.tasks-table tbody tr td:last-child button.done-btn {
  background: #e8f5e8;
  color: #28a745;
}
.tasks-table .table-task-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}
.tasks-table .table-task-name .task-name-text {
  flex: 1 1;
}
.tasks-table .table-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.tasks-table .table-actions .table-badge {
  position: relative;
  top: auto;
  right: auto;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  color: white;
  border-radius: 10px;
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  margin-left: 0.25rem;
}
.tasks-table .table-actions .table-badge.new-badge {
  background-color: darkgreen;
}
.tasks-table .table-actions .table-badge.updated-badge {
  background-color: darkcyan;
}
.tasks-table .table-actions .table-badge::before {
  content: "✨";
  position: absolute;
  top: -6px;
  right: -8px;
  font-size: 10px;
  animation: sparkle 1.5s infinite ease-in-out;
}

.tab-header {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.tab-header .tab {
  padding: 8px 18px;
  border: none;
  background-color: var(--border-color);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--text-color-medium);
  font-size: 0.85rem;
}
.tab-header .tab.active {
  background-color: var(--primary-color);
  color: var(--text-color-light);
}
.tab-header .tab:hover:not(.active) {
  color: var(--text-color-dark);
}

.task-grid {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 1rem;
  background-color: #f8f9fa;
  padding: 15px;
}

.task-card-main {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: calc(var(--spacing-unit) * 2);
  transition: all 0.2s ease-in-out;
  position: relative;
}
.task-card-main .badge {
  position: absolute;
  top: 0px;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.task-card-main .badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.task-card-main .new-badge {
  background-color: darkgreen;
}
.task-card-main .updated-badge {
  background-color: darkcyan;
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes sparkle {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.4) rotate(15deg);
  }
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes sparkle {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.4) rotate(15deg);
  }
}
.task-card-main .task-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
  padding-bottom: var(--spacing-unit);
  border-bottom: 1px solid var(--border-color);
}
.task-card-main .task-card-header .task-title-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}
.task-card-main .task-card-header .task-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-color-dark);
  margin: 0;
  line-height: 1.2;
}
.task-card-main .task-card-header .task-title .task-courtRef-tag {
  cursor: pointer;
}
.task-card-main .task-card-header .task-card-actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
  /* Prevent buttons from shrinking */
}
.task-card-main .task-card-header .task-card-actions .action-button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.task-card-main .task-card-header .task-card-actions .action-button:hover {
  opacity: 0.9;
  background: var(--container-bg);
}
.task-card-main .task-card-header .task-card-actions .action-button.status-btn {
  width: auto;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  border: none;
}
.task-card-main .task-card-header .task-card-actions .action-button.pending-btn {
  background: #fff3cd;
  color: #856404;
}
.task-card-main .task-card-header .task-card-actions .action-button.done-btn {
  background: #e8f5e8;
  color: #28a745;
}
.task-card-main .task-courtRef-tag {
  background-color: #f0f0f0;
  color: var(--text-color-medium);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.8em;
  margin-bottom: 0.5rem;
  font-weight: 500;
  border: 1px solid #d4d4d4;
  display: inline-block;
}
.task-card-main .task-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 0.75rem 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.4rem;
  font-size: 0.95rem;
  color: var(--text-color-medium);
}
.task-card-main .task-details-grid .detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.task-card-main .task-details-grid .detail-item.full-width {
  grid-column: 1/-1;
}
.task-card-main .task-details-grid .detail-icon {
  color: var(--primary-color);
  font-size: 1.15rem;
  flex-shrink: 0;
  /* Prevent icon from shrinking on narrow columns */
}
.task-card-main .task-details-grid .detail-label {
  font-weight: 600;
  color: var(--text-color-dark);
  flex-shrink: 0;
  /* Prevent label from shrinking */
}
.task-card-main .task-details-grid .detail-value {
  font-weight: 500;
  color: var(--text-color-dark);
  word-break: break-word;
  /* Allow long text to wrap */
}
.task-card-main .task-details-grid .detail-value.assigned-to-list {
  font-weight: normal;
  color: var(--text-color-medium);
}
.task-card-main .task-description {
  font-size: 0.9rem;
  color: var(--text-color-medium);
  line-height: 1.6;
  margin-bottom: var(--spacing-unit);
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}
.task-card-main .task-description .description-icon {
  color: var(--info-color);
  font-size: 1.15rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
}
.task-card-main .task-description p {
  margin: 0;
}
.task-card-main .task-description p strong {
  color: var(--text-color-dark);
}
.task-card-main .task-document {
  margin-top: calc(var(--spacing-unit) * 0.5);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.task-card-main .task-document .document-icon {
  color: var(--primary-color);
  font-size: 1.15rem;
  flex-shrink: 0;
}
.task-card-main .task-document a {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
}
.task-card-main .task-document a:hover {
  text-decoration: underline;
}

.no-tasks {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

/* Modal styles - Kept for completeness, consistent with previous version */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-box {
  background-color: white;
  padding: 2rem;
  width: 90%;
  max-width: 600px;
  border-radius: 0.75rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.3s ease-in-out;
  overflow-y: auto;
  max-height: 90vh;
}
.modal-box h2 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  text-align: center;
}
.modal-box input,
.modal-box textarea,
.modal-box select {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  border: 1px solid #cbd5e0;
  border-radius: 0.5rem;
  transition: border-color 0.2s;
}
.modal-box input:focus,
.modal-box textarea:focus,
.modal-box select:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.3);
}
.modal-box .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.modal-box .modal-actions .update-btn {
  background-color: var(--primary-color);
  color: white;
  padding: 0.6rem 1.2rem;
  border-radius: 0.375rem;
  border: none;
  font-weight: 500;
  cursor: pointer;
}
.modal-box .modal-actions .cancel-btn {
  background-color: var(--border-color);
  color: var(--text-color-dark);
  padding: 0.6rem 1.2rem;
  border-radius: 0.375rem;
  border: none;
  font-weight: 500;
  cursor: pointer;
}

.pagination-info {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  font-size: 0.9rem;
  color: #666;
  background: #f8f9fa;
  border-radius: 4px;
  margin-top: 1rem;
}
.pagination-info span:first-child {
  font-weight: 500;
  color: #333;
}
.pagination-info span:last-child {
  margin-left: 4px;
  font-style: italic;
}

.checkbox-dropdown {
  position: relative;
  width: 100%;
}
.checkbox-dropdown .checkbox-dropdown-header {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.checkbox-dropdown .checkbox-dropdown-header:hover {
  border-color: #007bff;
}
.checkbox-dropdown .checkbox-dropdown-header .dropdown-arrow {
  transition: transform 0.2s ease;
  font-size: 12px;
  color: #666;
}
.checkbox-dropdown .checkbox-dropdown-header .dropdown-arrow.open {
  transform: rotate(180deg);
}
.checkbox-dropdown .checkbox-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 999;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item:hover {
  background-color: #f8f9fa;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item:last-child {
  border-bottom: none;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item input[type=checkbox] {
  display: none;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item .checkmark {
  width: 16px;
  height: 16px;
  border: 2px solid #ddd;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item .checkmark::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item input[type=checkbox]:checked + .checkmark {
  background-color: #007bff;
  border-color: #007bff;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item input[type=checkbox]:checked + .checkmark::after {
  opacity: 1;
}
.checkbox-dropdown .checkbox-dropdown-content .checkbox-item .user-name {
  font-size: 14px;
  color: #333;
  flex: 1 1;
}
.checkbox-dropdown .checkbox-dropdown-content .loading-text {
  padding: 12px;
  text-align: center;
  font-style: italic;
  color: #666;
  font-size: 12px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
/* Responsive Styles */
@media (max-width: 768px) {
  .task-container {
    padding: var(--spacing-unit);
  }
  .task-grid {
    gap: var(--spacing-unit);
    grid-template-columns: 1fr;
  }
  .task-card-main {
    padding: calc(var(--spacing-unit) * 1.5);
  }
  .task-card-main .task-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: var(--spacing-unit);
  }
  .task-card-main .task-card-header .task-card-actions {
    align-self: flex-end;
  }
  .task-card-main .task-details-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: var(--spacing-unit);
  }
  .task-card-main .task-description,
  .task-card-main .task-document {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .task-container {
    padding: calc(var(--spacing-unit) * 0.5);
  }
  .task-card-mnain {
    padding: var(--spacing-unit);
  }
  .task-card-mnain .task-card-header .task-title {
    font-size: 1.1rem;
  }
  .task-card-mnain .task-details-grid .detail-item {
    font-size: 0.85rem;
  }
  .task-card-mnain .task-details-grid .detail-item .detail-icon {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Tasks/Task.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,0BAAA;EACA,4BAAA;EACA,2BAAA;EAEA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oCAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAAF;AAEE;EACE,WAAA;AAAJ;AAEE;EACA,cAAA;EACA,kBAAA;AAAF;;AAOA;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAJF;AAME;EACK,yBAAA;AAJP;AAMI;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AAJN;AAUI;EACE,sCAAA;AARN;AAUM;EACE,yBAAA;AARR;AAWM;EACE,oBAAA;AATR;AAaM;EACE,mBAAA;AAXR;AAaQ;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;AAXV;AAaU;EACE,YAAA;EACA,yBAAA;AAXZ;AAcU;EACE,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AAZZ;AAeU;EACE,mBAAA;EACA,cAAA;AAbZ;AAoBU;EACE,mBAAA;EACA,cAAA;AAlBZ;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AA5BJ;AA8BI;EACE,SAAA;AA5BN;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA9BJ;AAgCI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;EACA,mBAAA;EACA,oBAAA;AA9BN;AAgCM;EACE,2BAAA;AA9BR;AAiCM;EACE,0BAAA;AA/BR;AAkCM;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,4CAAA;AAhCR;;AAsCA;EACE,aAAA;EACA,WAAA;EAGA,eAAA;AArCF;AAuCE;EACE,iBAAA;EACA,YAAA;EACA,qCAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;AArCJ;AAuCI;EACE,sCAAA;EACA,8BAAA;AArCN;AAwCI;EAEE,6BAAA;AAvCN;;AA4CA;EACE,gBAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAzCF;;AA4CA;EACE,0BAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,gCAAA;EACA,kBAAA;AAzCF;AA2CE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AAzCJ;AA2CI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AAzCN;AA6CE;EACE,2BAAA;AA3CJ;AA8CE;EACE,0BAAA;AA5CJ;AA+CE;EACE;IACE,UAAA;IACA,qBAAA;EA7CJ;EAgDE;IACE,UAAA;IACA,mBAAA;EA9CJ;AACF;AAiDE;EAEE;IAEE,YAAA;IACA,gCAAA;EAjDJ;EAoDE;IACE,UAAA;IACA,mCAAA;EAlDJ;AACF;AAuDE;EACE;IACE,UAAA;IACA,qBAAA;EArDJ;EAwDE;IACE,UAAA;IACA,mBAAA;EAtDJ;AACF;AAyDE;EAEE;IAEE,YAAA;IACA,gCAAA;EAzDJ;EA4DE;IACE,UAAA;IACA,mCAAA;EA1DJ;AACF;AA+DE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,qBAAA;EACA,mCAAA;EACA,4CAAA;AA7DJ;AA+DI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AA7DN;AAgEI;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AA9DN;AAgEM;EACE,eAAA;AA9DR;AAqEI;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,mCAAA;AAnEN;AAqEM;EAYG,oBAAA;EACC,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA9EV;AAgFQ;EACE,YAAA;EACA,+BAAA;AA9EV;AAiFQ;EACE,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AAhFV;AAmFQ;EACE,mBAAA;EACA,cAAA;AAjFV;AAwFQ;EACE,mBAAA;EACA,cAAA;AAtFV;AAiGE;EACE,yBAAA;EACA,+BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA/FJ;AAkGE;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,+BAAA;AAhGJ;AAkGI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAhGN;AAkGM;EACE,iBAAA;AAhGR;AAoGI;EACE,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,kDAAA;AAlGN;AAqGI;EACE,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,iCAAA;AAnGN;AAsGI;EACE,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,4BAAA;AApGN;AAsGM;EACE,mBAAA;EACA,+BAAA;AApGR;AAyGE;EACE,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAvGJ;AAyGI;EACE,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAvGN;AA0GI;EACE,SAAA;AAxGN;AA0GM;EACE,6BAAA;AAxGR;AA6GE;EACE,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA3GJ;AA6GI;EACE,2BAAA;EACA,kBAAA;EACA,cAAA;AA3GN;AA8GI;EACE,2BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AA5GN;AA8GM;EACE,0BAAA;AA5GR;;AAkHA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA/GF;;AAkHA,2EAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AA/GF;;AAkHA;EACE,uBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,2CAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;AA/GF;AAiHE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AA/GJ;AAkHE;;;EAGE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;AAhHJ;AAkHI;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA9GN;AAkHE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAhHJ;AAkHI;EACE,sCAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAhHN;AAoHI;EACE,qCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAlHN;;AAuHA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AApHF;AAsHE;EACE,gBAAA;EACA,WAAA;AApHJ;AAuHE;EACE,gBAAA;EACA,kBAAA;AArHJ;;AA+OA;EACM,kBAAA;EACA,WAAA;AA5ON;AA8OM;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;AA5OR;AA8OQ;EACE,qBAAA;AA5OV;AA+OQ;EACE,+BAAA;EACA,eAAA;EACA,WAAA;AA7OV;AA+OU;EACE,yBAAA;AA7OZ;AAkPM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,wCAAA;AAhPR;AAkPQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,sCAAA;EACA,gCAAA;AAhPV;AAkPU;EACE,yBAAA;AAhPZ;AAmPU;EACE,mBAAA;AAjPZ;AAoPU;EACE,aAAA;AAlPZ;AAqPU;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAnPZ;AAqPY;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;EACA,6BAAA;AAnPd;AAuPU;EACE,yBAAA;EACA,qBAAA;AArPZ;AAuPY;EACE,UAAA;AArPd;AAyPU;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAvPZ;AA2PQ;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAzPV;;AA8PA;EACE;IACE,UAAA;IACA,sBAAA;EA3PF;EA8PA;IACE,UAAA;IACA,mBAAA;EA5PF;AACF;AA+PA,sBAAA;AACA;EACE;IACE,4BAAA;EA7PF;EAgQA;IACE,wBAAA;IACA,0BAAA;EA9PF;EAkQA;IACE,wCAAA;EAhQF;EAkQE;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;IACA,kCAAA;EAhQJ;EAkQI;IACE,oBAAA;EAhQN;EAoQE;IACE,0BAAA;IACA,WAAA;IACA,kCAAA;EAlQJ;EAqQE;;IAEE,kBAAA;EAnQJ;AACF;AAuQA;EACE;IACE,wCAAA;EArQF;EAwQA;IACE,4BAAA;EAtQF;EAyQI;IACE,iBAAA;EAvQN;EA4QI;IACE,kBAAA;EA1QN;EA4QM;IACE,eAAA;EA1QR;AACF","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --accent-color: #28a745;\n  --danger-color: #dc3545;\n  --warning-color: #ffc107;\n  --info-color: #17a2b8;\n  --text-color-dark: #343a40;\n  --text-color-medium: #6c757d;\n  --text-color-light: #f8f9fa;\n  --card-bg: #ffffff;\n  --container-bg: #f8f9fa;\n  --border-color: #e9ecef;\n  --shadow-light: rgba(0, 0, 0, 0.08);\n  --shadow-medium: rgba(0, 0, 0, 0.15);\n  --spacing-unit: 0.75rem;\n}\n\n.task-header-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.task-header-main .task-gap-header {\n  gap: 0.5rem;\n}\n.task-header-main .filter-group label {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.tasks-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px var(--shadow-light);\n}\n.tasks-table thead {\n  background-color: #f1f5f9;\n}\n.tasks-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: #111827;\n}\n.tasks-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n.tasks-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n.tasks-table tbody tr td {\n  padding: 0.9rem 1rem;\n}\n.tasks-table tbody tr td:last-child {\n  white-space: nowrap;\n}\n.tasks-table tbody tr td:last-child button {\n  margin-right: 0.5rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.tasks-table tbody tr td:last-child button:hover {\n  opacity: 0.9;\n  background-color: #fef9fa;\n}\n.tasks-table tbody tr td:last-child button.status-btn {\n  min-width: 4rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: 0.75rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  transition: all 0.2s ease;\n  border: none;\n}\n.tasks-table tbody tr td:last-child button.pending-btn {\n  background: #fff3cd;\n  color: #856404;\n}\n.tasks-table tbody tr td:last-child button.done-btn {\n  background: #e8f5e8;\n  color: #28a745;\n}\n.tasks-table .table-task-name {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  position: relative;\n}\n.tasks-table .table-task-name .task-name-text {\n  flex: 1;\n}\n.tasks-table .table-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.tasks-table .table-actions .table-badge {\n  position: relative;\n  top: auto;\n  right: auto;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 600;\n  color: white;\n  border-radius: 10px;\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n  white-space: nowrap;\n  margin-left: 0.25rem;\n}\n.tasks-table .table-actions .table-badge.new-badge {\n  background-color: darkgreen;\n}\n.tasks-table .table-actions .table-badge.updated-badge {\n  background-color: darkcyan;\n}\n.tasks-table .table-actions .table-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -6px;\n  right: -8px;\n  font-size: 10px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n\n.tab-header {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n.tab-header .tab {\n  padding: 8px 18px;\n  border: none;\n  background-color: var(--border-color);\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--text-color-medium);\n  font-size: 0.85rem;\n}\n.tab-header .tab.active {\n  background-color: var(--primary-color);\n  color: var(--text-color-light);\n}\n.tab-header .tab:hover:not(.active) {\n  color: var(--text-color-dark);\n}\n\n.task-grid {\n  margin-top: 1rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 1rem;\n  background-color: #f8f9fa;\n  padding: 15px;\n}\n\n.task-card-main {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 0.75rem;\n  padding: calc(var(--spacing-unit) * 2);\n  transition: all 0.2s ease-in-out;\n  position: relative;\n}\n.task-card-main .badge {\n  position: absolute;\n  top: 0px;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.task-card-main .badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.task-card-main .new-badge {\n  background-color: darkgreen;\n}\n.task-card-main .updated-badge {\n  background-color: darkcyan;\n}\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes sparkle {\n  0%, 100% {\n    opacity: 0.3;\n    transform: scale(1) rotate(0deg);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.4) rotate(15deg);\n  }\n}\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes sparkle {\n  0%, 100% {\n    opacity: 0.3;\n    transform: scale(1) rotate(0deg);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.4) rotate(15deg);\n  }\n}\n.task-card-main .task-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n  padding-bottom: var(--spacing-unit);\n  border-bottom: 1px solid var(--border-color);\n}\n.task-card-main .task-card-header .task-title-group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n}\n.task-card-main .task-card-header .task-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--text-color-dark);\n  margin: 0;\n  line-height: 1.2;\n}\n.task-card-main .task-card-header .task-title .task-courtRef-tag {\n  cursor: pointer;\n}\n.task-card-main .task-card-header .task-card-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  /* Prevent buttons from shrinking */\n}\n.task-card-main .task-card-header .task-card-actions .action-button {\n  margin-right: 0.5rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.task-card-main .task-card-header .task-card-actions .action-button:hover {\n  opacity: 0.9;\n  background: var(--container-bg);\n}\n.task-card-main .task-card-header .task-card-actions .action-button.status-btn {\n  width: auto;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.2s ease;\n  border: none;\n}\n.task-card-main .task-card-header .task-card-actions .action-button.pending-btn {\n  background: #fff3cd;\n  color: #856404;\n}\n.task-card-main .task-card-header .task-card-actions .action-button.done-btn {\n  background: #e8f5e8;\n  color: #28a745;\n}\n.task-card-main .task-courtRef-tag {\n  background-color: #f0f0f0;\n  color: var(--text-color-medium);\n  padding: 0.2em 0.6em;\n  border-radius: 0.25em;\n  font-size: 0.8em;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  border: 1px solid #d4d4d4;\n  display: inline-block;\n}\n.task-card-main .task-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 0.75rem 1rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.4rem;\n  font-size: 0.95rem;\n  color: var(--text-color-medium);\n}\n.task-card-main .task-details-grid .detail-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.task-card-main .task-details-grid .detail-item.full-width {\n  grid-column: 1/-1;\n}\n.task-card-main .task-details-grid .detail-icon {\n  color: var(--primary-color);\n  font-size: 1.15rem;\n  flex-shrink: 0;\n  /* Prevent icon from shrinking on narrow columns */\n}\n.task-card-main .task-details-grid .detail-label {\n  font-weight: 600;\n  color: var(--text-color-dark);\n  flex-shrink: 0;\n  /* Prevent label from shrinking */\n}\n.task-card-main .task-details-grid .detail-value {\n  font-weight: 500;\n  color: var(--text-color-dark);\n  word-break: break-word;\n  /* Allow long text to wrap */\n}\n.task-card-main .task-details-grid .detail-value.assigned-to-list {\n  font-weight: normal;\n  color: var(--text-color-medium);\n}\n.task-card-main .task-description {\n  font-size: 0.9rem;\n  color: var(--text-color-medium);\n  line-height: 1.6;\n  margin-bottom: var(--spacing-unit);\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n.task-card-main .task-description .description-icon {\n  color: var(--info-color);\n  font-size: 1.15rem;\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n.task-card-main .task-description p {\n  margin: 0;\n}\n.task-card-main .task-description p strong {\n  color: var(--text-color-dark);\n}\n.task-card-main .task-document {\n  margin-top: calc(var(--spacing-unit) * 0.5);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.task-card-main .task-document .document-icon {\n  color: var(--primary-color);\n  font-size: 1.15rem;\n  flex-shrink: 0;\n}\n.task-card-main .task-document a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n.task-card-main .task-document a:hover {\n  text-decoration: underline;\n}\n\n.no-tasks {\n  text-align: center;\n  font-size: 1.1rem;\n  color: var(--text-color-medium);\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n  background: var(--card-bg);\n  border-radius: 0.75rem;\n  border: 1px dashed var(--border-color);\n  box-shadow: 0 2px 5px var(--shadow-light);\n  margin-top: calc(var(--spacing-unit) * 2);\n  grid-column: 1/-1;\n}\n\n/* Modal styles - Kept for completeness, consistent with previous version */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-box {\n  background-color: white;\n  padding: 2rem;\n  width: 90%;\n  max-width: 600px;\n  border-radius: 0.75rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.3s ease-in-out;\n  overflow-y: auto;\n  max-height: 90vh;\n}\n.modal-box h2 {\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n  text-align: center;\n}\n.modal-box input,\n.modal-box textarea,\n.modal-box select {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  border: 1px solid #cbd5e0;\n  border-radius: 0.5rem;\n  transition: border-color 0.2s;\n}\n.modal-box input:focus,\n.modal-box textarea:focus,\n.modal-box select:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.3);\n}\n.modal-box .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n.modal-box .modal-actions .update-btn {\n  background-color: var(--primary-color);\n  color: white;\n  padding: 0.6rem 1.2rem;\n  border-radius: 0.375rem;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n}\n.modal-box .modal-actions .cancel-btn {\n  background-color: var(--border-color);\n  color: var(--text-color-dark);\n  padding: 0.6rem 1.2rem;\n  border-radius: 0.375rem;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.pagination-info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  font-size: 0.9rem;\n  color: #666;\n  background: #f8f9fa;\n  border-radius: 4px;\n  margin-top: 1rem;\n}\n.pagination-info span:first-child {\n  font-weight: 500;\n  color: #333;\n}\n.pagination-info span:last-child {\n  margin-left: 4px;\n  font-style: italic;\n}\n\n.checkbox-dropdown {\n  position: relative;\n  width: 100%;\n}\n.checkbox-dropdown .checkbox-dropdown-header {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n}\n.checkbox-dropdown .checkbox-dropdown-header:hover {\n  border-color: #007bff;\n}\n.checkbox-dropdown .checkbox-dropdown-header .dropdown-arrow {\n  transition: transform 0.2s ease;\n  font-size: 12px;\n  color: #666;\n}\n.checkbox-dropdown .checkbox-dropdown-header .dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n.checkbox-dropdown .checkbox-dropdown-content {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  max-height: 150px;\n  overflow-y: auto;\n  z-index: 999;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  border-bottom: 1px solid #f0f0f0;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item:hover {\n  background-color: #f8f9fa;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item:last-child {\n  border-bottom: none;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item input[type=checkbox] {\n  display: none;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item .checkmark {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ddd;\n  border-radius: 3px;\n  margin-right: 8px;\n  position: relative;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item .checkmark::after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item input[type=checkbox]:checked + .checkmark {\n  background-color: #007bff;\n  border-color: #007bff;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item input[type=checkbox]:checked + .checkmark::after {\n  opacity: 1;\n}\n.checkbox-dropdown .checkbox-dropdown-content .checkbox-item .user-name {\n  font-size: 14px;\n  color: #333;\n  flex: 1;\n}\n.checkbox-dropdown .checkbox-dropdown-content .loading-text {\n  padding: 12px;\n  text-align: center;\n  font-style: italic;\n  color: #666;\n  font-size: 12px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .task-container {\n    padding: var(--spacing-unit);\n  }\n  .task-grid {\n    gap: var(--spacing-unit);\n    grid-template-columns: 1fr;\n  }\n  .task-card-main {\n    padding: calc(var(--spacing-unit) * 1.5);\n  }\n  .task-card-main .task-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n    margin-bottom: var(--spacing-unit);\n  }\n  .task-card-main .task-card-header .task-card-actions {\n    align-self: flex-end;\n  }\n  .task-card-main .task-details-grid {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    margin-bottom: var(--spacing-unit);\n  }\n  .task-card-main .task-description,\n  .task-card-main .task-document {\n    font-size: 0.85rem;\n  }\n}\n@media (max-width: 480px) {\n  .task-container {\n    padding: calc(var(--spacing-unit) * 0.5);\n  }\n  .task-card-mnain {\n    padding: var(--spacing-unit);\n  }\n  .task-card-mnain .task-card-header .task-title {\n    font-size: 1.1rem;\n  }\n  .task-card-mnain .task-details-grid .detail-item {\n    font-size: 0.85rem;\n  }\n  .task-card-mnain .task-details-grid .detail-item .detail-icon {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
